import { render } from "./ImageEditorLocalImages.vue?vue&type=template&id=71d0f5c1"
import script from "./ImageEditorLocalImages.vue?vue&type=script&lang=js"
export * from "./ImageEditorLocalImages.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__